import React from 'react';
import { Button, Toast } from 'antd-mobile';
import styles from './crfPage.module.scss';
import CRFComponent from '../../component/crf/crf';
import config from '../../component/crf/config.json';
import utils from '../../utils/utils';
import { ApiCore } from '../../api/index';
const api = new ApiCore();

let env = process.env.REACT_APP_ENV;

declare const wx: any;

class Fullstop extends React.Component {
  render() {
    return <h1>{this.props.children}</h1>
  }
}

class CrfPage extends React.Component<any, any> {
  CrfRef: React.RefObject<any>;
  // @ts-ignore
  crfResolve: () => {};
  constructor(props: any) {
    super(props);
    let crfReqParam: any = sessionStorage.getItem('CrfReqParam');
    let _param = {
      channel: '',
      crfCode: '',
      crfVersion: '',
      recordCode: '',
      tenantCode: '',
      // tenantCode: 'TNT001',
      // channel: 'FOLLOWUP',
      // crfCode: 'FMLTFU001',
      // crfVersion: '1.0',
      // recordCode: 374,
      // tenantCode: 'TNT001',
      // channel: config.channel,
      // crfCode: 'CRF001',
      // crfVersion: '1.0',
      // recordCode: 'RC001',
      // tenantCode: 'TNT001',
      caseCode: '',
      eventCode: '',
      headers: {},
      projectCode: '',
      userCode: ''
    }
    try {
      crfReqParam = JSON.parse(crfReqParam);
      _param = {
        channel: config.channel,
        crfCode: crfReqParam.crfCode,
        crfVersion: crfReqParam.crfVersion,
        recordCode: crfReqParam.recordCode,
        // @ts-ignore
        tenantCode: crfReqParam.tenantCode,
        caseCode: crfReqParam.caseCode || crfReqParam.caseId,
        eventCode: crfReqParam.followId || crfReqParam.eventCode,
        headers: {},
        projectCode: crfReqParam.projectCode,
        userCode: crfReqParam.userCode
      }
    } catch (error) {
      crfReqParam = {};
    }
    let urlParams = utils.getUrlParams() || {};
    this.state = {
      // showCrf: (urlParams.urlType === 'addPatientDetail' || urlParams.urlType === 'addPatient' ) ? false : true,
      showCrf: (urlParams.urlType === 'patientHome') ? false : true,
      // showCrf: false,
      params: _param,
      dynamicComponent: []
    };
    this.CrfRef = React.createRef()
  }

  componentDidMount() {
    let urlParams = utils.getUrlParams();
    if (urlParams.urlType === 'patientHome') {
      this.setState({
        dynamicComponent: [require('../patient/patientHome/patientHome').default]
      })
    }
  }

  // 数据保存
  onSave = () => {
    return new Promise<void>((resolve, reject) => {
      // @ts-ignore
      this.crfResolve = resolve;
      this.CrfRef.current.handleSubmit();
    })
  }

  // 是否可以编辑
  toEdit = (isEdit = false) => {
    // isEdit -> readonly
    this.CrfRef.current.init(!isEdit);
  }

  onSaveSuccess = (value: any) => {
    Toast.success('保存成功！');
    console.log("[onSaveSuccess]", value);
    this.crfResolve(value);
  }

  onShow = (param: any) => {
    console.log(' onShow ', 'deleverd');
    console.log(' param ', param);
    let crfReqParam = param;
    let _param = {
      channel: config.channel,
      crfCode: crfReqParam.crfCode,
      crfVersion: crfReqParam.crfVersion,
      recordCode: crfReqParam.recordCode,
      // @ts-ignore
      tenantCode: crfReqParam.tenantCode,
      caseCode: crfReqParam.caseCode || crfReqParam.caseId,
      eventCode: crfReqParam.followId || crfReqParam.eventCode,
      headers: {},
      projectCode: crfReqParam.projectCode,
      userCode: crfReqParam.userCode
    }
    this.setState({ params: _param})
  }

  render() {
    let { params, dynamicComponent, showCrf } = this.state;
    return (
      <div className={styles.crf_page}>
          {dynamicComponent.length > 0 && dynamicComponent.map((DynamicComponent: any, index: any) => (
              <div key={index}>
                  <DynamicComponent
                      onShow={this.onShow}
                      onSave={this.onSave}
                      toEdit={this.toEdit}
                      props={this.props}
                  >
                      <div className={styles.crf_content}>
                          <CRFComponent
                            ref={this.CrfRef}
                            params={params}
                            onSaveSuccess={(v: any) => this.onSaveSuccess(v)}
                          />
                      </div>
                  </DynamicComponent>
              </div>
          ))}
        {/* 父应用标题 */}
        {
          showCrf &&
            <div className={styles.crf_content}>
                <CRFComponent
                  ref={this.CrfRef}
                  params={params}
                  onSaveSuccess={(v: any) => this.onSaveSuccess(v)}
                />
          </div>
        }

        {/* <Button type='primary' onClick={this.onSave}>保存</Button> */}
      </div>
    );
  }
}
export default CrfPage;
